import _ from 'lodash';

function ShowReportController($q, PageHeading, $stateParams, Report, $filter, ReportComponent, $state, $window, Auth, Toast) {
	'ngInject';

	const vm = this;
	vm.paginationInfo = ReportComponent.getPaginationInfo();
	vm.query = null;
	vm.allReports = {};
	vm.showReport = generateFilteredResult() || fetchAllReports().then( (response) => { vm.allReports = response; });
	vm.totalPrice = ReportComponent.getTotalPriceCurrencies();
	vm.printWindow = printWindow;
	vm.stateParams = $stateParams;
	vm.ticketNumberFrom = parseInt($stateParams.from, 10);
	vm.showTicketType = showTicketType;
	$window.scrollTo(0, 0);
	vm.filteredTotalPrice = Report.total_price;
	vm.filteredByTicketNumber = Report.tickets ? true : false;
	vm.showResults = false;

	/** */
	function showTicketType(type) {
		if (type === 'default') {
			return 'NOT_INSPECTED';
		} else {
			let ticketType = '';

			type ? ticketType = type.toUpperCase() : 0;
			// Return locale key have to be in uppercase
			return ticketType;
		}
	}

	activate();

	function activate() {
		const heading = $filter('translate')('HEADING.PRINT_REPORT');
		const title = `BTMS | ${$filter('translate')('HEADING.PRINT_REPORT')}`;
		const isCurrentUserOwner = _.find(Auth.getCurrentUser().roles, {'name': 'owner'});
		const isCurrentUserAdministrator = _.find(Auth.getCurrentUser().roles, {'name': 'administrator'});

		PageHeading.setPageHeading(heading, title);
		
		if (!isCurrentUserOwner && !isCurrentUserAdministrator && Auth.getCurrentUser().id !== parseInt($stateParams.userId, 10)) {
			Toast.error($filter('translate')('ERRORS.NOT_AUTHORISED'));
			$state.go(`app.private.reports.list`);
		}
	}

	function printWindow() {
		$window.print();
	}

	/** */
	function fetchAllReports() {
		const  deferred = $q.defer();
		const itemsPerRequest = 800;
		const loopCycles = Math.ceil( ReportComponent.getPaginationInfo().total / itemsPerRequest );
		const reports = [];
		const dates = {
			'from': $stateParams.from,
			'to': $stateParams.to
		};
		
		for (let i = 0; i < loopCycles; i++) {
			 ReportComponent.fetchReports($stateParams.userId, dates, `${ i + 1 }`, $stateParams.type, $stateParams.review, itemsPerRequest, $stateParams.paymentSystem)
				.then( response => {
					if (response.errors) {
						Toast.responseError(response.data.errors);
						$state.go(`app.private.reports.list`);
					}

					for ( let k = 0; k < response.length; k++) {
						reports.push(response[ k ]);

						if (i === loopCycles - 1 && k === response.length - 1 ) {
							deferred.resolve(reports);

							if ( deferred.promise.$$state.status === 1 ) {
								vm.showResults = true;
							}
						}
					}
				});
				
		}
		
		return deferred.promise;
	}
	
	/** */
	function generateFilteredResult() {
		if (Report.tickets) {
			const startValue = parseInt($stateParams.from, 10);
			const endValue = parseInt($stateParams.to, 10);
			const resultTickets = Report.tickets;
			const resultArray = emptyArrayCreator(startValue, endValue);
			let filteredReports = [];

			for ( let i = 0, k = resultTickets.length; i < k; i++ ) {
				const match = resultArray.indexOf(parseInt(resultTickets[i].number, 10));
				resultArray[match] = resultTickets[i];
			}
			filteredReports = resultArray;

			return filteredReports;

		} else {
			return Report.tickets;
		}
	}

	/** Generates an empty array
	 * @params { Number } - loop start from
	 * @params { Number } - Loop to value
	 * @return { Array } - array of number values between start and end point
	 */
	function emptyArrayCreator(from, to) {
		const emptyArray = [];

		for ( let i = from, k = to; i <= k; i++ ) {
			emptyArray.push(i);
		}

		return 	emptyArray;
	}
}

export default ShowReportController;



/** WEBPACK FOOTER **
 ** ./client/private/reports/show/show.controller.js
 **/